import createGlobalEventActions from 'web-app/react/global-event/helpers/create-actions';
import { createAction } from 'signin-app/redux/helpers';
export const { updateError, updateSuccess, updateInfo, updateStatus, clearStatus } = createGlobalEventActions(createAction);
